export default {
  get_all: { method: "get", url: "api/planos-exitos" },
  show: { method: "get", url: "api/planos-exitos{/id}" },
  store: { method: "post", url: "api/planos-exitos" },
  update: { method: "put", url: "api/planos-exitos{/id}" },
  delete: { method: "delete", url: "api/planos-exitos{/id}" },
};
